import { cloneDeep } from "lodash";

export const capFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

// Replaces undefined with null and strips empty-string keys so payload is Firebase-safe.
export const removeUndefined = (obj) => {
    return cleanObj(cloneDeep(obj));
};

// const cleanObj = (object) => {
//     Object.entries(object).forEach(([k, v]) => {
//         if (v === undefined) {
//             object[k] = null;
//         } else if (v && typeof v === "object") {
//             cleanObj(v);
//         }
//     });
//     return object;
// };

/** Dot/bracket paths of own properties whose value is strictly `undefined` (pre-Firebase sanitize). */
export const collectUndefinedPaths = (value, path = "") => {
    if (value === undefined) {
        return path ? [path] : [];
    }

    if (value === null || typeof value !== "object") {
        return [];
    }

    if (Array.isArray(value)) {
        return value.flatMap((item, index) => {
            const itemPath = path ? `${path}[${index}]` : `[${index}]`;
            return collectUndefinedPaths(item, itemPath);
        });
    }

    return Object.entries(value).flatMap(([key, nested]) => {
        const keyPath = path ? `${path}.${key}` : key;

        if (nested === undefined) {
            return [keyPath];
        }

        return collectUndefinedPaths(nested, keyPath);
    });
};

function cleanObj(object) {
    if (object === null || typeof object !== "object") {
        return object === undefined ? null : object;
    }
    if (Array.isArray(object)) {
        return object.map((item) => (item === undefined ? null : cleanObj(item)));
    }
    return Object.fromEntries(
        Object.entries(object)
            .filter(([key]) => key !== "" && key != null) // drop empty or null keys
            .map(([key, value]) => [key, value === undefined ? null : cleanObj(value)])
    );
}
